const S3_BASE =
  "https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/tutorial";

const STEPS = [
  { image: `${S3_BASE}/counsel.webp`, title: "20초 상담" },
  { image: `${S3_BASE}/grant.webp`, title: "지원금 받기" },
  {
    image: `${S3_BASE}/Interest-free.webp`,
    title: "무이자 할부 진행",
    subtitle: (
      <p className="text-body-3 text-[#4F4F4F]">
        (실제 월 부담금 <strong>3만원</strong>)
      </p>
    ),
  },
  { image: `${S3_BASE}/exec.webp`, title: "채권도시 변호사들의\n전략 실행" },
  { image: `${S3_BASE}/retrieval.webp`, title: "내 돈 회수 성공!" },
];

export const TutorialSection = () => {
  return (
    <section className="flex flex-col gap-[32px] items-center px-[16px] tablet:px-[32px] py-[80px] bg-[#f6f6f9] desktop:pt-[76px] desktop:pb-[160px]">
      <h2 className="text-heading-1-mb desktop:text-heading-1">
        이렇게 간편하게 진행돼요
      </h2>

      <div className="flex flex-col items-center gap-[24px] desktop:flex-row desktop:gap-[20px]">
        {/* 1~3번 카드 */}
        <div className="flex flex-col items-center gap-[24px] tablet:flex-row tablet:gap-[20px] text-[#212121]">
          {STEPS.slice(0, 3).map((step, i) => (
            <TutorialCard key={i} step={step} number={i + 1} />
          ))}
        </div>

        {/* 4~5번 카드 */}
        <div className="flex flex-col items-center gap-[24px] tablet:flex-row tablet:gap-[20px]">
          {STEPS.slice(3).map((step, i) => (
            <TutorialCard key={i + 3} step={step} number={i + 4} />
          ))}
        </div>
      </div>
    </section>
  );
};

type Step = {
  image: string;
  title: string;
  subtitle?: React.ReactNode;
};

const TutorialCard = ({ step, number }: { step: Step; number: number }) => {
  return (
    <article className="relative tablet:max-w-[212px]">
      <img
        src={step.image}
        alt={step.title}
        loading="lazy"
        decoding="async"
        className="rounded-t-[24px]"
      />

      <div className="h-[90px] bg-white rounded-b-[25px] flex flex-col items-center justify-center text-heading-3 text-center">
        <p className="whitespace-pre-line">{step.title}</p>
        {step.subtitle}
      </div>

      <div className="absolute top-[14px] right-[14px] text-[#4F4F4F] bg-white/80 w-[56px] h-[56px] tablet:w-[44px] tablet:h-[44px] rounded-full flex items-center justify-center text-display-2 font-light">
        {number}
      </div>
    </article>
  );
};
